import { useCallback, useState } from 'react'

export function useDismissible(
  storageKey: string,
  expiryDate?: Date
): readonly [dismissed: boolean, dismiss: () => void] {
  const [dismissed, setDismissed] = useState(() => {
    if (expiryDate && new Date() >= expiryDate) return true
    return sessionStorage.getItem(storageKey) === 'true'
  })

  const dismiss = useCallback(() => {
    sessionStorage.setItem(storageKey, 'true')
    setDismissed(true)
  }, [storageKey])

  return [dismissed, dismiss] as const
}
